$(document).ready(function() {
  $(document).on("click",".banner-slider",function() {
     var data_url = $(this).data("link");
     window.location.href = data_url;
  });
  $('.hero-banner-slider').slick({
    slidesToShow: 1,
    dots:true,
    arrows:true,
    autoplay: true,
    autoplaySpeed: 2000,
  });
});